// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-mark{position:absolute;top:0;bottom:0;left:0;right:0;margin:0 auto;z-index:100}", ""]);
// Exports
module.exports = exports;
